<script setup>
const props = defineProps({
  visible: {
    type: Boolean,
    default: true
  }
})

import {Link} from "@inertiajs/vue3";
import {usePage} from "@inertiajs/vue3";
import MenuItem from "./mobile-menu/MenuItem.vue";
import { trans } from 'laravel-vue-i18n';

const emit = defineEmits(['open-settings'])

const menuItems = [
    {
        title: trans('common.nav_forms'),
        icon: 'pi pi-file',
        route: '/app/forms'
    },

    {
        title: trans('common.nav_reservations'),
        icon: 'pi pi-calendar',
        route: '/app/reservations'
    },

    {
        title: trans('common.nav_requests'),
        icon: 'pi pi-envelope',
        route: '/app/reservations/requests'
    },

    {
        title: trans('common.settings'),
        icon: 'pi pi-cog',
        click: () => emit('open-settings')
    }
]
</script>

<template>
  <Transition name="slide-menu">
    <div v-if="props.visible" class="mobile-menu">
        <div class="mobile-menu-pill">
            <template v-for="menuItem in menuItems" :key="menuItem.title">
                <MenuItem :title="menuItem.title" :item="menuItem.icon" :route="menuItem.route" :icon="menuItem.icon"
                          @click.prevent="menuItem.click()"/>
            </template>
        </div>
        <!-- OBLONG STŘEDOVÉ TLAČÍTKO -->
        <Link href="/app/forms/wizard" class="big-btn">
            <i class="pi pi-plus"></i>
            <span class="max-sm:hidden">{{ $t('common.add') }}</span>
        </Link>
    </div>
  </Transition>
</template>

<style lang="scss">
/* GLASSMORPHIC EFEKT */
.mobile-menu {
    @apply fixed bottom-5 left-1/2 -translate-x-1/2 w-[93%] z-50 flex gap-4 justify-between;

    .mobile-menu-pill {
        @apply flex justify-around items-center !max-h-[53px] bg-white/30 dark:bg-neutral-900/40 backdrop-blur-lg border dark:border-neutral-700 rounded-full flex-row p-2 shadow-lg transition-all duration-300;
    }


    /* OBLONG BUTTON */

    .big-btn {
    @apply max-sm:w-14 max-sm:h-14 sm:px-6 sm:py-3 flex flex-row items-center justify-center text-white bg-blue-600 dark:bg-blue-500 rounded-full text-lg shadow-lg transition-all duration-200 transform scale-100 hover:scale-105 active:scale-95;
    }

    .big-btn i {
    @apply text-xl sm:mr-2 max-sm:mb-0;
    }

    .big-btn span {
    @apply text-sm font-semibold;
    }

    .big-btn:hover {
    @apply bg-blue-700 dark:bg-blue-400;
    }
}

/* Only fade for the whole bar */
.slide-menu-enter-active, .slide-menu-leave-active {
  transition: opacity 0.3s ease;
}
.slide-menu-enter-from {
  opacity: 0;
}
.slide-menu-enter-to {
  opacity: 1;
}
.slide-menu-leave-from {
  opacity: 1;
}
.slide-menu-leave-to {
  opacity: 0;
}

/* Slide left for pill */
.mobile-menu-pill {
  transition: transform 0.3s ease;
}
.slide-menu-enter-from .mobile-menu-pill {
  transform: translateX(-100%);
}
.slide-menu-enter-to .mobile-menu-pill {
  transform: translateX(0);
}
.slide-menu-leave-from .mobile-menu-pill {
  transform: translateX(0);
}
.slide-menu-leave-to .mobile-menu-pill {
  transform: translateX(-100%);
}

/* For big-btn opposite direction */
.big-btn {
  transition: transform 0.3s ease;
}
.slide-menu-enter-from .big-btn {
  transform: translateX(100%);
}
.slide-menu-enter-to .big-btn {
  transform: translateX(0);
}
.slide-menu-leave-from .big-btn {
  transform: translateX(0);
}
.slide-menu-leave-to .big-btn {
  transform: translateX(100%);
}
</style>
